import { Link } from "react-router-dom";
import { getTableFormattedDate } from "../../helpers/date-time-helper";
import { ColumnDef, createColumnHelper } from "@tanstack/table-core";
import { TUserMachineWithRole } from "./types";
import { TUserMachineRole } from "../../common/types/user-machine-role";

type TableUsersDevices = Pick<TUserMachineWithRole, 'serialNumber' | 'role' | 'type' | 'machineName' | 'created' | 'lastActive'>
type TValue = string | number | TUserMachineRole;

const columnHelper = createColumnHelper<TableUsersDevices>();

export const COLUMNS: ColumnDef<TableUsersDevices, TValue>[] = [
    columnHelper.accessor<'serialNumber', string>('serialNumber', {
        id: "serialNumber",
        header: "Serial #",
        enableColumnFilter: false,
        cell: (props) => (
            <Link to={`../machines/${props.getValue()}`}>
                {props.getValue()}
            </Link>
        ),
    }),
    columnHelper.accessor<'role', TUserMachineRole>('role', {
        id: 'role',
        header: 'Role',
        enableColumnFilter: false,
        cell: (cellProps) => (
            <span className="text-capitalize">{cellProps.row.original.role}</span>
        ),
    }),
    columnHelper.accessor<'type', string>('type', {
        id: 'type',
        header: 'Machine Type',
        enableColumnFilter: false,
    }),
    columnHelper.accessor<'machineName', string>('machineName', {
        id: 'machineName',
        header: 'Name',
        enableColumnFilter: false,
    }),
    columnHelper.accessor<'created', string>('created', {
        id: 'created',
        header: 'Date Added',
        enableColumnFilter: false,
        cell: (props) => getTableFormattedDate(props.getValue()),
    }),
    columnHelper.accessor<'lastActive', string>('lastActive', {
        id: 'lastActive',
        header: 'Last Active',
        enableColumnFilter: false,
        cell: (props) => getTableFormattedDate(props.getValue()),
    }),
];
